/**
 * This tracks the status during the ID Verification flow for Lending.
 */
export enum IdUploadStatus {
    INITIATED = "INITIATED",
    STARTED = "STARTED",
    FINISHED = "FINISHED",
    CANCELED = "CANCELED",
    RETRY = "RETRY",
    ERROR = "ERROR"
}



// WEBPACK FOOTER //
// ./src/constants/IdUploadStatus.ts